// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"266":"78cde15d6603195e7f420b50719087c3","284":"413b83843c409412b45a0c2692fc674f"}[chunkId] + ".js";
};